$bog_blitz_lobby $mol_page
	Head null
	players_string @ \Players
	land_id \
	quiz_title \
	Host $bog_blitz_lobby_host
		counter_string <= counter_string \
		land_id <= land_id
		quiz_title <= quiz_title
		session <= session null
		quiz_data <= quiz_data null
		Players <= Host_players $bog_blitz_lobby_players
			players_dict <= players_dict null
			my_lord_str <= my_lord_str \
	Join_screen $bog_blitz_lobby_join
		player_name? <=> my_player_name? \
		avatar_files? <=> my_avatar_files? /File
		join? <=> join? null
		is_synced <= is_synced false
		player_id <= my_lord_str
		profile_avatar_uri <= profile_avatar_uri \
		profile_name <= profile_name \
	Waiting $bog_blitz_lobby_waiting
		counter_string <= counter_string \
		quiz_title <= quiz_title
		Players <= Host_players $bog_blitz_lobby_players
			players_dict <= players_dict null
			my_lord_str <= my_lord_str \
	No_game $mol_view
		sub /
			<= No_game_text $mol_paragraph
				title @ \No active game
			<= Go_admin $mol_button_major
				title @ \Go to Admin
				click? <=> go_admin? null
	Game_screen $bog_blitz_lobby_game
		land_id <= land_id
		session <= session null
		quiz_data <= quiz_data null
		game_state <= game_state \
		current_question <= current_question null
		current_question_text <= current_question_text \
		my_player <= my_player null
		my_answers <= my_answers null
		is_host <= is_host false
		paused_at <= paused_at 0
		manual_mode <= manual_mode false
		round_start <= round_start 0
		duration <= duration 0
		total_questions <= total_questions 0
		current_question_index <= current_question_index 0
		players_dict <= players_dict null
		my_lord_str <= my_lord_str
	Reactions $bog_blitz_lobby_reactions
		my_answers <= my_answers null
		players_dict <= players_dict null
		is_host <= is_host false
	body <= lobby_content /
